import React, { useEffect, useState } from 'react';
import { getMyTeamData } from '../service/api';
import '../components/css/Dashboard-styles.css';
import { useNavigate } from 'react-router-dom';
import AddFeedback from './AddFeedbackForm';
import { workDayURL } from '../constant';
import { getS3 } from '../utils/Download.js';


const MyTeamData = () => {
    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [domain, setDomain] = useState('');
    const [totalMember, setTotalMember] = useState(0);
    const [search, setSearch] = useState('');
    const [empId, setEmpId] = useState('');
    const [empName, setEmpName] = useState('');
    const [empDomain, setEmpDomain] = useState('');
    const [hideFeedbackForm, setHideFeedbackForm] = useState(true);
    const [coverImageUrls, setCoverImageUrls] = useState({});
    const [iconUrls, setIconUrls] = useState({});

    useEffect(() => {
        fetchApi();
    }, []);
    useEffect(() => {
        (async () => {
            const coverUrlPromises = data.map(async datum => {
                const url = datum.cover_img_url ? await getS3(datum.cover_img_url) : '/Images/profile-banner.jpg';
                return [datum.emp_id, url];
            });
            const iconUrlPromises = data.map(async datum => {
                const url = datum.icon_url ? await getS3(datum.icon_url) : null;
                return [datum.emp_id, url];
            });
    
            const coverUrls = await Promise.all(coverUrlPromises);
            const iconUrls = await Promise.all(iconUrlPromises);
    
            setCoverImageUrls(Object.fromEntries(coverUrls));
            setIconUrls(Object.fromEntries(iconUrls));
        })();
    }, [data]);

    const fetchApi = async () => {
        const resp = await getMyTeamData();

        let data = "", length = 0;

        if (resp?.data?.ResponseData?.length) {
            setData(resp.data.ResponseData);
            data = resp?.data?.ResponseData[0].domain;
            length = resp?.data?.ResponseData.length;
        }
        setDomain(data);



        setTotalMember(length);
    };

    const handleEnterKey = (e) => {
        if (e.charCode == 13) {
            handleSearch();
        }
    };

    const handleSearch = async () => {
        try {
            const data = {
                search: search.trim(),
            };

            const resp = await getMyTeamData(data);

            let length;

            if (resp?.data?.ResponseData?.length) {

                setData(resp.data.ResponseData);

                length = resp?.data?.ResponseData.length;

                setTotalMember(length);
            }
            else {
                setData([])
                setTotalMember(0)
            }

            //setdomain();
        } catch (err) {

        }
    };

    const setsearch = (e) => {
        try {
            setSearch(e.target.value);
        } catch (err) {

        }
    };

    const navigateFunc = (page, data = '') => {
        if (page == 'todo') {
            // window.location.href = `https://ava-cind-todoapp-fe-prod.azurewebsites.net/${data.userId}/myTODO`;

            // window.location.href = `https://workdaynp.avasoft.com/apiservice/hive/${data.userId}/myTODO`;

            window.location.href = `${workDayURL}#/${data.empId}/teamTODO`

        } else if (page == 'appreciation') {
            navigate('/appreciationform', { state: { empId: data.empId } });
        } else if (page == 'performance') {

            window.location.href = `/profilecontainer?EmpId=${data.empId}&tab=performance`
        }
    };

    const myTeamBody = () => {
        try {
            // setdomain();

            if (data.length) {

                return data.map((datum, i) => {
                    return (
                        <>
                            <div className="col-md-3">
                                <div className="card h-100 dashboard-myteam-card-height">
                                    <img
                                    src={coverImageUrls[datum.emp_id] || "/Images/profile-banner.jpg"}
                                    style={{ maxHeight: "77px" }}
                                    className="card-img-top position-relative"
                                    alt="..."
                                />
                                    <div className="position-absolute dashboard-profile-position">
                                        <img src="/Images/logo-person-user-person-icon.jpg" className="dashboard-profile-image-style" />
                                    </div>
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between pt-5 pb-4">
                                            <div>
                                                <h5 className="card-title tt-bold font-15 mb-0">{datum.emp_name}</h5>
                                                <p className="card-text mb-0 font-12 lable-color">{datum.domain}</p>
                                                <a className="font-12 text-decoration-none">
                                                    {datum.email_id}
                                                </a>
                                            </div>
                                            <div className="align-self-center">

                                                {datum.grand_rating ? <>  <h4 className="tt-bold font-18 pe-3 dashboard-activities-count">
                                                    <span>
                                                    <img src={iconUrls[datum.emp_id]} className="dashboard-group-emoji-size" />
                                                    </span>
                                                    {datum.grand_rating}
                                                </h4></> : <></>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer dashboard-team-footer d-flex justify-content-between border-0">
                                        <a
                                            onClick={() => {
                                                navigateFunc('todo', { empId: datum.emp_id });
                                            }}
                                            className="font-12 text-decoration-none"
                                        >
                                            <img src="/Images/todo.png" style={{ cursor: "pointer" }} title="Todo" className="dashboard-todo-size" />
                                        </a>
                                        <a
                                            onClick={() => {
                                                setEmpId(datum.emp_id)
                                                setEmpName(datum.emp_name)
                                                setEmpDomain(datum.domain)
                                                setHideFeedbackForm(false)
                                            }}
                                            className="font-12 text-decoration-none"
                                            data-bs-toggle="modal"
                                            data-bs-target="#AddFeedbackDetailsPopup"
                                        >
                                            <img src="/Images/flag.png" style={{ cursor: "pointer" }} title="Feedback" className="dashboard-flag-size" />
                                        </a>
                                        <a
                                            onClick={() => {
                                                navigateFunc('appreciation', { empId: datum.emp_id });
                                            }}
                                            className="font-12 text-decoration-none"
                                        >
                                            <img src="/Images/Appreciation.png" style={{ cursor: "pointer" }} title="Appreciation" className="dashboard-appreciation-size" />
                                        </a>
                                        <a
                                            onClick={() => {

                                                navigateFunc('performance', { empId: datum.emp_id });

                                            }}
                                            className="font-12 text-decoration-none"
                                        >
                                            <img src="/Images/Performance.png" style={{ cursor: "pointer" }} title="Performance" className="dashboard-performance-size" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </>
                    );
                });
            }
            else {

                return (<>

                    <div className="row justify-content-center">
                        <img
                            src="/Images/vadivelu.png"
                            alt="nodatafound"
                            //className="nofeedbackimg-sty"
                            style={{ width: '45%' }}
                        />

                        <h2 className="tt-bold font-15 text-center margin-negative">No Records Found</h2>
                    </div>

                </>
                )
            }




        } catch (err) {

        }
    };

    return (
        <>
            <div className="row">
                <div className="col-md-12 py-3 d-flex justify-content-center align-items-center">
                    <h1 className="tt-bold font-15">{`${domain ? domain : 'Human Resource'} (${totalMember})`}</h1>
                    {/* Search*/}
                    <div className="ms-auto d-flex">
                        <div className="input-group flex-nowrap dashboard-search-group me-3">
                            <input
                                type="search"
                                className="form-control dashboard-search-align"
                                placeholder="Search"
                                aria-label="Username"
                                aria-describedby="addon-wrapping"
                                value={search}
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                }}
                                onKeyPress={(e) => handleEnterKey(e)}
                            />
                            <button className="input-group-text btn dashboard-btn-search-custom" id="addon-wrapping">
                                <img
                                    src="/Images/search-icon.svg"
                                    alt="search-icon"
                                    onClick={() => {
                                        handleSearch();
                                    }}
                                />
                            </button>
                        </div>
                    </div>
                    {/* Search*/}
                </div>
            </div>

            <div className={data.length ? "row row-cols-1 row-cols-md-3 g-4 mt-3" : ""}  >{myTeamBody()}</div>

            <AddFeedback empId={empId} empName={empName} empDomain={empDomain} ReloadGridPage={null} hideFeedbackForm={hideFeedbackForm} setHideFeedbackForm={() => setHideFeedbackForm()} />
        </>
    );
};

export default MyTeamData;
